var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 260,
    viewBox: "0 0 100 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -40H100V260L50 237L0 260V-40Z",
    fill: "#FF5500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2914_10762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -40,
    width: 100,
    height: 300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -40H100V260L50 237L0 260L0 -40Z",
    fill: "#F0F0F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2914_10762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-38.6309 107.081L-35.1426 94.0629L-28.7379 95.779L-30.2073 101.263L-4.37949 108.183L-2.91014 102.7L3.49448 104.416L0.00616945 117.434L-38.6309 107.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.0898 75.2058L-26.6015 62.1873L-20.1969 63.9034L-21.6663 69.3871L4.16152 76.3076L5.63087 70.8239L12.0355 72.54L8.54719 85.5586L-30.0898 75.2058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.4258 42.8688L-17.9375 29.8502L-11.5329 31.5663L-13.0022 37.05L12.8256 43.9706L14.2949 38.4869L20.6996 40.203L17.2112 53.2215L-21.4258 42.8688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.8848 10.9932L-9.39646 -2.02538L-2.99184 -0.309267L-4.46119 5.17443L21.3666 12.095L22.836 6.61127L29.2406 8.32738L25.7523 21.3459L-12.8848 10.9932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.0879 251.036L-11.5996 238.017L-5.19496 239.733L-6.66431 245.217L19.1635 252.138L20.6328 246.654L27.0374 248.37L23.5491 261.389L-15.0879 251.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.54688 219.16L-3.05857 206.142L3.34605 207.858L1.8767 213.341L27.7045 220.262L29.1738 214.778L35.5785 216.494L32.0902 229.513L-6.54688 219.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11719 186.823L5.6055 173.805L12.0101 175.521L10.5408 181.004L36.3686 187.925L37.8379 182.441L44.2425 184.157L40.7542 197.176L2.11719 186.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6582 154.948L14.1465 141.929L20.5511 143.645L19.0818 149.129L44.9096 156.049L46.3789 150.566L52.7835 152.282L49.2952 165.3L10.6582 154.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3242 122.611L22.8125 109.592L29.2171 111.308L27.7478 116.792L53.5756 123.712L55.0449 118.229L61.4496 119.945L57.9612 132.963L19.3242 122.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8652 90.735L31.3535 77.7164L37.7582 79.4326L36.2888 84.9162L62.1166 91.8368L63.586 86.3531L69.9906 88.0692L66.5023 101.088L27.8652 90.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5293 58.3979L40.0176 45.3794L46.4222 47.0955L44.9529 52.5792L70.7807 59.4997L72.25 54.0161L78.6546 55.7322L75.1663 68.7507L36.5293 58.3979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0703 26.5223L48.5586 13.5038L54.9632 15.2199L53.4939 20.7036L79.3217 27.6241L80.791 22.1404L87.1957 23.8566L83.7073 36.8751L45.0703 26.5223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7344 -5.8147L57.2227 -18.8332L63.6273 -17.1171L62.158 -11.6334L87.9857 -4.7129L89.4551 -10.1966L95.8597 -8.48048L92.3714 4.53806L53.7344 -5.8147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9727 60.9086L94.4843 73.9271L100.889 75.6432L102.358 70.1595L128.186 77.0801L126.717 82.5638L133.121 84.2799L136.61 71.2613L97.9727 60.9086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3086 93.2455L85.8203 106.264L92.2249 107.98L93.6943 102.496L119.522 109.417L118.053 114.901L124.457 116.617L127.946 103.598L89.3086 93.2455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7676 125.121L77.2793 138.14L83.6839 139.856L85.1532 134.372L110.981 141.293L109.512 146.776L115.916 148.492L119.405 135.474L80.7676 125.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1035 157.458L68.6152 170.477L75.0198 172.193L76.4892 166.709L102.317 173.63L100.848 179.113L107.252 180.829L110.741 167.811L72.1035 157.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5625 189.334L60.0742 202.352L66.4788 204.068L67.9482 198.585L93.776 205.505L92.3066 210.989L98.7112 212.705L102.2 199.687L63.5625 189.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8965 221.671L51.4082 234.689L57.8128 236.405L59.2821 230.922L85.1099 237.842L83.6406 243.326L90.0452 245.042L93.5335 232.024L54.8965 221.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3555 253.546L42.8672 266.565L49.2718 268.281L50.7411 262.797L76.5689 269.718L75.0996 275.202L81.5042 276.918L84.9925 263.899L46.3555 253.546Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.89f6a5c1cd1b906e707b7c96140ee198.svg";
export { ForwardRef as ReactComponent };